import React, { Component } from 'react';
import WithNavigation from '../../layouts/WithNavigation';
import HomeownerOnboardingComponent from '../../components/HomeOwnerDashboard/HomeownerOnboarding/HomeownerOnboardingComponent';

export default class HomeownerOnboarding extends Component {

    render() {
        return (
            <WithNavigation
                title="Dashboard"
                border
                top={
                    <HomeownerOnboardingComponent />
                }
            />
        )
    }
}
